export default "assets/images/flags/it-1a249e10.svg";